import { api } from '../../shared/api/client';

export type SnapshotKind = '2d' | '3d' | 'doc';
export type SnapshotStatus = 'pending' | 'uploaded' | 'processing' | 'ready' | 'failed';

export interface Snapshot {
  id: string;
  patientId?: string | null;
  examinationId?: string | null;
  title: string;
  description: string;
  kind: SnapshotKind;
  modality: string;
  status: SnapshotStatus;
  originalSize: number;
  originalMime: string;
  originalName: string;
  /** Кадров в снимке: 1 — плоское изображение, >1 — объём (многокадровый DICOM). */
  frames: number;
  /** Непустой — файл принадлежит DICOM-серии (том листается одним стеком). */
  seriesUid?: string;
  instanceNumber?: number;
  createdAt: string;
  updatedAt?: string;
}

/** Ответ GET /v1/snapshots/{id}: снимок + presigned-ссылки. */
export interface SnapshotDetail extends Snapshot {
  viewUrl: string;
  downloadUrl: string;
  /** JPEG-дериваты от воркера; отсутствуют, пока снимок не обработан. */
  thumbnailUrl?: string;
  previewUrl?: string;
}

export interface SnapshotList {
  items: Snapshot[];
  total: number;
  limit?: number;
  offset?: number;
}

export interface CreateSnapshotRequest {
  title: string;
  description?: string;
  kind: SnapshotKind;
  modality?: string;
  fileName: string;
  contentType: string;
}

export interface CreateSnapshotResponse {
  snapshot: Snapshot;
  uploadUrl: string;
  uploadMethod: 'PUT';
}

// Ниже — контракт запросов к API. Пока backend отвечает 501; реализация
// эндпоинтов и точная форма ответов фиксируются отдельным ТЗ.

export async function listSnapshots(params: { kind?: SnapshotKind; page?: number } = {}) {
  const { data } = await api.get<SnapshotList>('/v1/snapshots', { params });
  return data;
}

export async function getSnapshot(id: string) {
  const { data } = await api.get<SnapshotDetail>(`/v1/snapshots/${id}`);
  return data;
}

export async function createSnapshot(body: CreateSnapshotRequest) {
  const { data } = await api.post<CreateSnapshotResponse>('/v1/snapshots', body);
  return data;
}

export async function completeSnapshot(id: string, checksum?: string) {
  const { data } = await api.post<Snapshot>(`/v1/snapshots/${id}/complete`, { checksum });
  return data;
}

export async function deleteSnapshot(id: string) {
  await api.delete(`/v1/snapshots/${id}`);
}
